import React, { useEffect } from 'react';

import { EvTextInputSearch } from '@evinced-private/ui-common';

import './NavigationMenuSearch.scss';

interface NavigationMenuSearchProps {
	searchId: string;
	searchTerm: string;
	onSearchChange: (value: string) => void;
	onKeyDown: (event: React.KeyboardEvent) => void;
	searchInputRef: React.RefObject<HTMLInputElement>;
	activedescendant?: string;
}

export const NavigationMenuSearch: React.FC<NavigationMenuSearchProps> = ({
	searchId,
	searchTerm,
	onSearchChange,
	onKeyDown,
	searchInputRef,
	activedescendant
}) => {
	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
		// Call the parent keyDown handler for all keys
		// Tab will be handled by parent to close dropdown
		onKeyDown(event);
	};

	// Set aria-activedescendant for screen reader navigation
	useEffect(() => {
		if (searchInputRef.current) {
			if (activedescendant) {
				searchInputRef.current.setAttribute('aria-activedescendant', activedescendant);
			} else {
				searchInputRef.current.removeAttribute('aria-activedescendant');
			}
		}
	}, [activedescendant, searchInputRef]);

	return (
		<div className="navigation-menu__search">
			<EvTextInputSearch
				ref={searchInputRef}
				id={searchId}
				value={searchTerm}
				onChange={onSearchChange}
				placeholder="Search"
				ariaLabel="Search business units"
				onKeyDown={handleKeyDown}
			/>
		</div>
	);
};
